module.exports = __webpack_public_path__ + "static/media/profileIconLight.c6cea0ca.svg";